define("ember-in-viewport/utils/can-use-raf", ["exports", "ember-in-viewport/utils/can-use-dom"], function (_exports, _canUseDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = canUseRAF;
  0; //eaimeta@70e063a35619d71f0,"ember-in-viewport/utils/can-use-dom"eaimeta@70e063a35619d71f

  function checkRAF(window, rAF, cAF) {
    let x;
    let vendors = ['ms', 'moz', 'webkit', 'o'];

    for (x = 0; x < vendors.length && !window[rAF]; ++x) {
      window[rAF] = window[`${vendors[x]}RequestAnimationFrame`];
      window[cAF] = window[`${vendors[x]}CancelAnimationFrame`] || window[`${vendors[x]}CancelRequestAnimationFrame`];
    }

    if (window[rAF] && window[cAF]) {
      return true;
    } else {
      return false;
    }
  }

  function canUseRAF() {
    if (!_canUseDom.default) {
      return false;
    }

    return checkRAF(window, 'requestAnimationFrame', 'cancelAnimationFrame');
  }
});